require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-what-englands-world-cup-run-can-teach-you-about-your-content-marketing.json") })
        }
      }, "path---news-what-englands-world-cup-run-can-teach-you-about-your-content-marketing");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-what-englands-world-cup-run-can-teach-you-about-your-content-marketing!./.cache/json/news-what-englands-world-cup-run-can-teach-you-about-your-content-marketing.json
// module id = 1440
// module chunks = 231608221292675